"use client"
import React from "react";
import aboutPage from '@/public/aboutPage/iaCoverFace.png';
import Image from "next/image";
import {LuArrowRight} from "react-icons/lu";
import {useRouter} from "next/navigation";
import "@/app/styles/gradient.css";
import "@/app/styles/new-ui-styles.css";

export default function About() {
    const router = useRouter();

    return (
        <div className="relative min-h-screen w-full bg-white overflow-auto">
            {/* Circular gradient background */}
            <div 
                className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1400px] h-[1400px] pointer-events-none"
                style={{
                    background: `
                        radial-gradient(
                            circle,
                            rgba(69, 96, 243, 0.35) 0%,
                            rgba(168, 97, 255, 0.22) 25%,
                            rgba(205, 176, 239, 0.12) 45%,
                            rgba(255, 255, 255, 0.00) 65%
                        )
                    `,
                }}
            />
            
            <div className="relative w-full py-4 px-4 md:px-6">
                <div className="max-w-6xl mx-auto">
                    {/* Simple navigation */}
                    <nav className="flex justify-between items-center mb-6 md:mb-8 lg:mb-12 px-2">
                        <div 
                            className="headline-150-bold text-newui-primary cursor-pointer hover:opacity-80 transition-opacity"
                            onClick={() => router.push('/new-login')}
                        >
                            EON
                        </div>
                        <button
                            className="h-10 px-5 btn-newui-send-gradient text-white rounded-full 
                                       inline-flex items-center justify-center
                                       button-300-medium
                                       transition-all duration-200"
                            onClick={() => router.push('/new-login')}
                        >
                            Log in
                        </button>
                    </nav>
                </div>

                {/* Main content */}
                <div className="min-h-[calc(100vh-120px)] flex flex-col items-center justify-center w-full pb-8">
                    <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 items-center justify-center w-full max-w-[1080px]">
                        {/* Text content card */}
                        <div className="w-full lg:w-1/2 mb-6 lg:mb-0">
                            <div className="aspect-square rounded-2xl bg-white shadow-sm p-8 md:p-10 lg:p-12 flex flex-col">
                                {/* EON Logo inline with floating animation */}
                                <div className="mb-6 animate-levitate">
                                    <svg width="72" height="72" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M64 16C74.5 16 92 36.5714 92 64C92 91.4286 74.5 112 64 112C53.5 112 36 91.4286 36 64C36 36.5714 53.5 16 64 16Z" fill="url(#paint0_about)"/>
                                        <path d="M16 68C16 57.5 36.5714 40 64 40C91.4286 40 112 57.5 112 68C112 78.5 91.4286 96 64 96C36.5714 96 16 78.5 16 68Z" fill="url(#paint1_about)"/>
                                        <ellipse cx="50" cy="60" rx="6" ry="12" fill="white">
                                            <animate attributeName="ry" values="12;1;12" dur="0.3s" begin="0s;blink1_about.end+4.7s" id="blink1_about"/>
                                        </ellipse>
                                        <ellipse cx="78" cy="60" rx="6" ry="12" fill="white">
                                            <animate attributeName="ry" values="12;1;12" dur="0.3s" begin="0s;blink2_about.end+4.7s" id="blink2_about"/>
                                        </ellipse>
                                        <defs>
                                            <linearGradient id="paint0_about" x1="64" y1="16" x2="64" y2="112" gradientUnits="userSpaceOnUse">
                                                <stop stopColor="#0027F9"/>
                                                <stop offset="1" stopColor="#A861FF"/>
                                            </linearGradient>
                                            <linearGradient id="paint1_about" x1="64" y1="16" x2="64" y2="112" gradientUnits="userSpaceOnUse">
                                                <stop stopColor="#0027F9"/>
                                                <stop offset="1" stopColor="#A861FF"/>
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </div>
                                
                                <h1 className="headline-275-bold text-newui-primary mb-2">
                                    About <span className="text-newui-accent">EON</span>
                                </h1>
                                
                                <p className="body-200-regular text-newui-label mb-6">
                                    Powered by PayRetailers
                                </p>
                                
                                <div className="mt-auto">
                                    <p className="body-300-regular text-newui-secondary leading-relaxed mb-8">
                                        EON is PayRetailers' internal AI assistant, designed to provide operational support and instant access to company knowledge. Through natural conversations, you can streamline workflows, access compliance guidelines, and navigate our partner ecosystem.
                                    </p>
                                    
                                    {/* CTA Button */}
                                    <button
                                        className="h-12 px-6 btn-newui-send-gradient text-white rounded-full 
                                                   inline-flex items-center justify-center gap-2
                                                   button-300-medium
                                                   transition-all duration-200"
                                        onClick={() => router.push('/new-login')}
                                    >
                                        Get started
                                        <LuArrowRight size={18}/>
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Image - no container styling */}
                        <div className="w-full lg:w-1/2">
                            <div className="aspect-square">
                                <Image
                                    src={aboutPage}
                                    alt="Digital Technology Visualization"
                                    className="w-full h-full object-cover rounded-2xl"
                                    priority
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}